import { render } from "./NetScore.vue?vue&type=template&id=1ad30d0a"
import script from "./NetScore.vue?vue&type=script&lang=js"
export * from "./NetScore.vue?vue&type=script&lang=js"
script.render = render

export default script